let INFOS_APPID43a99c //邦客惠权益小程序缓存
let INFOS_APPIDd442cf //邦客惠权益公众号缓存
let INFOS_APPID10 //其他小程序缓存

//土特产小程序appId：wxfcb34416b1538017   H5公众号：wx9a373b1354d442cf
let H5_APPID = "wx9a373b1354d442cf"

//url字符串截取
export const getQueryString = (key) => {
  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)")
  var result = window.location.search.substr(1).match(reg)
  return result ? decodeURIComponent(result[2]) : null
}

//获取本地缓存--存储基本数据类型
export const getStorage = (key) => {
  const value = localStorage.getItem(key)
  if (value && value !== "undefined" && value !== "null") {
    return value
  }
  return null
}

//获取本地缓存--存储对象
export const getObjStorage = (key) => {
  const value = localStorage.getItem(key)
  if (value && value !== "undefined" && value !== "null") {
    return JSON.parse(value)
  }
  return null
}

//存入本地缓存
export const setStorage = (key, value) => {
  if (typeof value != "string") {
    //复杂数据类型储存
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    //基本数据类型储存
    localStorage.setItem(key, value)
  }
}

//存入sessionStorage
export const setSession = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}
//读取sessionStorage
export const getSession = (key) => {
  let value = sessionStorage.getItem(key)
  if (value === null || value === undefined || value === "") {
    return null
  }
  return JSON.parse(value)
}

//根据不同的appId删除对应的键名缓存
export const delAppIdStorage = (appId) => {
  let k = ""
  let keyName = ""
  if (getStorage("environment") == "wxBrowser") {
    //公众号的appId默认
    setStorage("appId", H5_APPID)
    keyName = "INFOS_APPID" + H5_APPID.substring(appId.length - 6)
  } else {
    //嵌套H5中，获取url中k值作为缓存键名
    k = getQueryString("k") || appId.substring(appId.length - 6)

    keyName = "INFOS_APPID" + k
  }
  localStorage.removeItem(keyName)
}

//根据不同的appId读取不同的内容
export const getAppIdStorage = (appId) => {
  let k = ""
  let keyName = ""
  if (getStorage("environment") == "wxBrowser") {
    //公众号的appId默认

    setStorage("appId", H5_APPID)
    keyName = "INFOS_APPID" + H5_APPID.substring(appId.length - 6)
  } else {
    //嵌套H5中，获取url中k值作为缓存键名
    k = getQueryString("k") || appId?.substring(appId.length - 6)

    keyName = "INFOS_APPID" + k
  }

  //截取appId后六位作为键名
  return JSON.parse(localStorage.getItem(keyName))
}

//根据不同的appId读取不同的内容
export const setAppIdStorage = (appId, value) => {
  let k = ""
  let keyName = ""
  if (getStorage("environment") == "wxBrowser") {
    //公众号的appId默认
    setStorage("appId", H5_APPID)
    keyName = "INFOS_APPID" + H5_APPID.substring(appId.length - 6)
  } else {
    //嵌套H5中，获取url中k值作为缓存键名
    k = getQueryString("k") || appId?.substring(appId.length - 6)
    keyName = "INFOS_APPID" + k
  }

  //截取appId后六位作为键名
  localStorage.setItem(keyName, JSON.stringify(value))
}

//存储数据时加上时间戳
export const setLocalStorageAndTime = (key, value) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      data: value,
      time: new Date().getTime(),
    })
  )
}

//对localstorage中的时间戳做对比
export const getLocalStorageAndTime = (key, exp = 600000) => {
  // 获取数据
  let data = localStorage.getItem(key)
  console.log("getLocalStorageAndTime", exp, data)
  if (!data) return null
  let dataObj = JSON.parse(data)
  // 与过期时间比较
  if (new Date().getTime() - dataObj.time > exp) {
    // 过期删除返回null
    localStorage.removeItem(key)
    return null
  } else {
    return dataObj.data
  }
}
